(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('axolotl-gallery')) {
    customElements.define(
      'axolotl-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-gallery-dialog]');
          this.image = this.querySelector('[data-gallery-image]');
          this.triggers = [...this.querySelectorAll('[data-gallery-trigger]')];
          this.index = 0;

          this.addEventListener('click', (event) => {
            const trigger = event.target.closest('[data-gallery-trigger]');
            if (trigger) this.open(Number(trigger.dataset.galleryIndex));
            if (event.target.closest('[data-gallery-close]')) this.dialog.close();
            if (event.target.closest('[data-gallery-previous]')) this.show(this.index - 1);
            if (event.target.closest('[data-gallery-next]')) this.show(this.index + 1);
          });

          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });

          this.dialog.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.show(this.index - 1);
            if (event.key === 'ArrowRight') this.show(this.index + 1);
          });
        }

        open(index) {
          this.show(index);
          this.dialog.showModal();
        }

        show(index) {
          if (!this.triggers.length) return;
          this.index = (index + this.triggers.length) % this.triggers.length;
          const trigger = this.triggers[this.index];
          this.image.src = trigger.dataset.fullImage;
          this.image.alt = trigger.dataset.imageAlt;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
